import { render, staticRenderFns } from "./OddsEvent.vue?vue&type=template&id=65a5121d"
import script from "./OddsEvent.vue?vue&type=script&lang=ts"
export * from "./OddsEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports